// src/AuthRouter.jsx
import React from "react";
import { useSearchParams, Navigate } from "react-router-dom";
import Register from "./Register";      // your file above
// import Login from "./Login";         // if/when you have it

const AuthRouter = () => {
  const [sp] = useSearchParams();
  const mode = (sp.get("mode") || "login").toLowerCase();

  if (mode === "register") return <Register />;

  // if you have a Login component, return it here instead:
  // if (mode === "login") return <Login />;

  // fallback: send to dedicated login route (keeps ?next & ?aff)
  const params = sp.toString();
  return <Navigate replace to={`/login${params ? `?${params}` : ""}`} />;
};

export default AuthRouter;
